import { selectDepartments } from "app/containers/AdminConsole/slice";
import { Department } from "app/containers/AdminConsole/types";
import { Dropdown } from "react-bootstrap";
import { useAppSelector } from "utils/redux/hooks";

interface DepartmentDropdownProps {
  showSample?: boolean;
  onSelect: (departmentId: number | null) => void;
  selectedDepartmentId?: number | null;
  toggleStyles?: React.CSSProperties;
}
const DepartmentDropdown = ({
  showSample = false,
  selectedDepartmentId,
  onSelect,
  toggleStyles,
}: DepartmentDropdownProps) => {
  const departments = useAppSelector(selectDepartments);
  const selectedDepartment = selectedDepartmentId
    ? departments[selectedDepartmentId]
    : null;

  const getDepartmentOption = (department: Department) => (
    <Dropdown.Item
      eventKey={department.departmentId}
      key={department.departmentId}
    >
      <p className="single-line-clamp text-overflow-ellipsis">
        {department?.name ?? ""}
      </p>
    </Dropdown.Item>
  );

  const getDepartmentOptions = () => {
    let departmentArray = Object.values(departments);
    if (!showSample) {
      departmentArray = departmentArray.filter((d) => d.companyAccountId !== 0);
    }
    const options: JSX.Element[] = [];
    departmentArray.forEach((d, idx) => {
      options.push(getDepartmentOption(d));
      if (idx !== departmentArray.length - 1) {
        options.push(<Dropdown.Divider key={`divider-${d.departmentId}`} />);
      }
    });
    return options;
  };

  return (
    <Dropdown
      onSelect={(e) => {
        onSelect(Number(e) || null);
      }}
    >
      <Dropdown.Toggle
        variant="light"
        className="dropdown-menu-240px"
        style={{
          ...toggleStyles,
        }}
      >
        <p
          className={`single-line-clamp text-overflow-ellipsis ${
            selectedDepartment ? "" : "grey-text"
          }`}
        >
          {selectedDepartment?.name ?? "Select a department"}
        </p>
      </Dropdown.Toggle>

      <Dropdown.Menu className="w-100">{getDepartmentOptions()}</Dropdown.Menu>
    </Dropdown>
  );
};

export default DepartmentDropdown;
